import { useQuery } from '@tanstack/react-query';
import { getCurrentUser, type CurrentUser } from '../api/client';

export function useCurrentUser() {
  return useQuery<CurrentUser>({
    queryKey: ['currentUser'],
    queryFn: getCurrentUser,
    staleTime: 5 * 60 * 1000,
  });
}
